/**
 * Konfiguracja Google reCAPTCHA Enterprise
 */

export const RECAPTCHA_CONFIG = {
  // Klucz witryny (Site Key) - używany w przeglądarce
  get SITE_KEY(): string {
    return process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || '';
  },

  // Tajny klucz API (Secret Key / API Key) - używany TYLKO na serwerze
  get SECRET_KEY(): string {
    return process.env.RECAPTCHA_SECRET_KEY || '';
  },

  // Google Cloud Project ID - wymagany dla Enterprise
  get PROJECT_ID(): string {
    return process.env.RECAPTCHA_PROJECT_ID || '';
  },

  // Wersja reCAPTCHA
  VERSION: "enterprise" as const,
};

/**
 * Sprawdza czy reCAPTCHA jest skonfigurowana
 */
export function isRecaptchaConfigured(): boolean {
  return Boolean(RECAPTCHA_CONFIG.SITE_KEY);
}

export default RECAPTCHA_CONFIG;
